// extracted by mini-css-extract-plugin
export default {"BuildCityButton":"BuildCityButton_BuildCityButton__ToBxH","BuildCityButtonNormal":"BuildCityButton_BuildCityButtonNormal__hsIua"};